import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { resolveValueDisplay } from '@app/hcs-shared';
import { ModuleFE_Advisor_DiseaseProfile, ModuleFE_Advisor_FindingView, ModuleFE_Advisor_MeasurementUnit, ModuleFE_Advisor_Pathway, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable, Renderer_ThreeDotLoader } from '@app/advisor-frontend';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { capitalizeAllFirstLetters } from '@nu-art/ts-common';
export const props_advisorValueDropdown = {
    module: ModuleFE_Advisor_Value,
    modules: [ModuleFE_Advisor_Value],
    mapper: item => [resolveValueDisplay(item)],
    placeholder: 'Enter Value',
    renderer: item => _jsx(_Fragment, { children: resolveValueDisplay(item, true) }),
};
export const AdvisorDropDown_Values = GenericDropDownV3.prepare(props_advisorValueDropdown);
const props_advisorMeasurementUnitDropdown = {
    module: ModuleFE_Advisor_MeasurementUnit,
    modules: [ModuleFE_Advisor_MeasurementUnit],
    mapper: item => [item.unitAsString],
    placeholder: 'Choose a measurement unit',
    renderer: item => _jsx(_Fragment, { children: item.unitAsString }),
};
export const AdvisorDropDown_MeasurementUnits = GenericDropDownV3.prepare(props_advisorMeasurementUnitDropdown);
const props_advisorPathwayDropdown = {
    module: ModuleFE_Advisor_Pathway,
    modules: [ModuleFE_Advisor_Pathway],
    mapper: item => [item.label],
    placeholder: 'Choose a protocol',
    renderer: item => _jsx(_Fragment, { children: item.label }),
};
export const AdvisorDropdown_Pathway = GenericDropDownV3.prepare(props_advisorPathwayDropdown);
const props_advisorVariableDropdown = {
    module: ModuleFE_Advisor_Variable,
    modules: [ModuleFE_Advisor_Variable],
    mapper: item => [item.name],
    limitItems: 50,
    placeholder: 'Choose a variable',
    renderer: item => _jsx(_Fragment, { children: item.name }),
};
export const AdvisorDropdown_Variable = GenericDropDownV3.prepare(props_advisorVariableDropdown);
const props_advisorFindingViewDropdown = {
    module: ModuleFE_Advisor_FindingView,
    modules: [ModuleFE_Advisor_FindingView],
    mapper: item => [item.label],
    limitItems: 50,
    placeholder: 'Choose a finding view',
    renderer: item => _jsx(_Fragment, { children: item.label }),
};
export const AdvisorDropdown_FindingView = GenericDropDownV3.prepare(props_advisorFindingViewDropdown);
const props_advisorDpDropdown = {
    module: ModuleFE_Advisor_DiseaseProfile,
    modules: [ModuleFE_Advisor_DiseaseProfile],
    mapper: item => [item.label],
    limitItems: 50,
    placeholder: 'Choose a diagnosis',
    caret: DropDown_DefaultCaret,
    renderer: item => _jsx(_Fragment, { children: capitalizeAllFirstLetters(item.label) }),
};
export const AdvisorDropdown_DiseaseProfile = GenericDropDownV3.prepare(props_advisorDpDropdown);
export const ButtonLoadingRenderer = () => {
    return _jsxs(LL_H_C, { className: 'wizard-button__loader', children: [_jsx("div", { className: 'wizard-button__loader__text', children: "Updating" }), _jsx(Renderer_ThreeDotLoader, { color: '#3083ff', fadedColor: '#3083ff22' })] });
};
//# sourceMappingURL=AdvisorUiComponents.js.map